import { motion } from "framer-motion";
import { User, Bell, Link, Users, Camera, Check, Slack, Mail, Smartphone, Building2 } from "lucide-react";
import { NavLink, useLocation, Outlet } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { InputVenture } from "@/components/ui/input-venture";
import { VentureCard, VentureCardHeader, VentureCardTitle, VentureCardContent } from "@/components/ui/venture-card";
import { BadgeVenture } from "@/components/ui/badge-venture";
import { cn } from "@/lib/utils";

const tabs = [
  { icon: User, label: "Account", path: "/settings/account" },
  { icon: Building2, label: "Company", path: "/settings/company" },
  { icon: Bell, label: "Notifications", path: "/settings/notifications" },
  { icon: Link, label: "Integrations", path: "/settings/integrations" },
  { icon: Users, label: "Team", path: "/settings/team" },
];

export default function Settings() {
  const location = useLocation();
  
  return (
    <motion.div
      className="space-y-6"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4 }}
    >
      {/* Tabs */}
      <div className="flex items-center gap-2 border-b border-border pb-4">
        {tabs.map((tab) => {
          const isActive = location.pathname === tab.path;
          
          return (
            <NavLink
              key={tab.label}
              to={tab.path}
              className={cn(
                "flex items-center gap-2 px-4 py-2 text-sm font-medium rounded-lg transition-colors",
                isActive
                  ? "bg-secondary/20 text-secondary"
                  : "text-muted-foreground hover:text-foreground hover:bg-accent"
              )}
            >
              <tab.icon className="w-4 h-4" />
              {tab.label}
            </NavLink>
          );
        })}
      </div>

      {/* Content rendered by nested routes */}
      <Outlet />
    </motion.div>
  );
}
